import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const ModalText = styled("p")(() => ({
  color: "#232325",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "150%",
  fontFamily: "Inter",
}));

export const WarningText = styled("p")(() => ({
  fontWeight: 400,
  fontSize: 16,
  lineHeight: "150%",
  color: "#F79009",
  fontStyle: "italic",
  fontFamily: "Inter",
}));

const styles = makeStyles(() => ({
  actionsButtonsSection: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    padding: "0px 1.2rem 0px 0.5rem",
  },
  previousButton: {
    border: "1px solid #e4e7ec",
    color: "#465869",
  },
  rightButtonSection: {
    width: "40%",
    display: "flex",
    gap: ".625rem",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  downloadCSVButton: {
    paddingLeft: "1.25rem",
    paddingRight: "1.25rem",
  },
  buttonSize: {
    width: "30%",
  },
  w520: {
    width: "520px !important",
  },
}));

export default styles;
